import { useEffect } from 'react';

/**
 * M's FIELD (CampingSpace) ページ用の scroll fade-up フック。
 * 主要セクションとカードに camp-fade-up クラスをマーキングし、
 * 可視範囲入りで is-visible を付与する。
 */
export default function useCampFadeUp() {
  useEffect(() => {
    const targets = document.querySelectorAll(
      '.camping-header, ' +
      '.intro-section, .notice-section, .facilities-section, .pricing-section, .rules-section, .contact-section, ' +
      '.facility-card, .pricing-card, .rule-item, .info-card, ' +
      '.camping-container > h2'
    );
    targets.forEach((el) => el.classList.add('camp-fade-up'));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );
    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}
